module.exports = __webpack_public_path__ + "static/22nd-1820ebb222ef0aa1647f1720830a1fa9.png";